import {gql} from "@apollo/client";


export const ACTION_TAKEN_ON_USER_NOTIFICATION = gql`mutation ActionTakenOnUserNotification($value: Long!){
    actionTakenOnUserNotification (
        userNotificationId: $value
)
    {
                       id
                       type
                       notificationUuid
    }
}`;

